type ToasterPosition = "tl" | "tr" | "bl" | "br";
type ToasterProps = {
  position?: ToasterPosition;
};

import { useLocation } from "react-router-dom";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  ToastIcon,
} from "./toast";
import { useToast } from "alm-react-components";
import { useEffect } from "react";

export function Toaster({ position = "br" }: ToasterProps) {
  const { toasts } = useToast();
  const location = useLocation();
  const { dismiss } = useToast();
  useEffect(() => {
    dismiss();
  }, [location.pathname]);

  return (
    <ToastProvider duration={5000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex justify-center items-center gap-2">
              <div>
                <ToastIcon variant={props.variant} />
              </div>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport position={position} />
    </ToastProvider>
  );
}
